export function createBasicIframe(iframeTitle: string) {
  const iframe = document.createElement('iframe');
  iframe.frameBorder = '0';
  iframe.tabIndex = -1;
  iframe.setAttribute('title', iframeTitle);
  return iframe;
}
